import { useMutation } from "@tanstack/react-query";
import { triggerNotification } from "components/TheComponents/Notification";
import { useAppContext } from "contexts";
import { ExceptionHandlingType } from "types/apiServiceTypes";
import { getErrorMessageFromResponse } from "helpers/apiHelpers";

export function useCreateSiteRewardMutation({ onHandleSuccess }: { onHandleSuccess?: () => void }) {
  const { apiService } = useAppContext();

  return useMutation({
    mutationFn: async ({ formData, otp }: { formData: FormData; otp: string }) => {
      const response = await apiService.form(
        "/site-rewards/create",
        formData,
        ExceptionHandlingType.MANUAL,
        { method: "POST", headers: { "x-otp": otp } }
      );
      return response;
    },
    onSuccess: () => {
      triggerNotification({ text: "Site Reward Created!", type: "success" });
      onHandleSuccess?.();
    },
    onError: (error) => {
      triggerNotification({ type: "error", text: getErrorMessageFromResponse(error) });
    },
  });
}
